import React from "react";
import {purgeState} from "./storePersistence";
import {languages} from "./common";
import {localization as aigStrings} from './aigStrings';
import {localization as anselStrings} from './anselStrings';
import {localization as nationwideStrings} from './nationwideStrings';
import {localization as renaissanceStrings} from './renaissanceStrings';
import {localization as symetraStrings} from './symetraStrings';

const SP_NAME = process.env.REACT_APP_SP_NAME;

const stringsMapping = {
    aig: aigStrings,
    ansel: anselStrings,
    nationwide: nationwideStrings,
    renaissance: renaissanceStrings,
    symetra: symetraStrings,
};

export const interpolateString = (str, [...args]) => {
    try {
        args.forEach((a, idx) => {
            const key = "$" + (idx + 1);
            while (str.indexOf(key) > -1) {
                str = str.replace(key, a);
            }
        });
        return str;
    } catch (e) {
        console.error("Interpolate String error", {str}, {args}, {e});
        purgeState();
        window.location.reload(true);
    }
};

export const parseMultilineString = (str, args = null) => {
    try {
        if (args !== null) {
            str = interpolateString(str, args);
        }
        const lines = str.split("\n");
        const linesCount = lines.length;
        return lines.map((line, idx) => {
            const nbsps = line.split("&nbsp;");
            return <React.Fragment key={line}>{nbsps.join('\u00A0')}{idx < linesCount - 1 && <br/>}</React.Fragment>
        });
    } catch (e) {
        console.error({e});
        purgeState();
        window.location.reload(true);
    }
};

export const parseSingleUnderlinedWordInString = (str) => {
    try {
        if (!str) {
            return str;
        }
        const parts = str.split("__");
        if (parts.length !== 3) {
            console.error("parseSingleUnderlinedWordInString only works for one word in the given string");
            return str;
        }
        return <React.Fragment>{parts[0]}<u>{parts[1]}</u>{parts[2]}</React.Fragment>;
    } catch (e) {
        console.error({e});
        purgeState();
        window.location.reload(true);
    }
}

export const getLocalization = (language) => {
    const selectedLocalization = stringsMapping[SP_NAME];
    const defaultLang = languages.ENGLISH;
    let strings = selectedLocalization[defaultLang];
    if (language === languages.ENGLISH || language === languages.SPANISH) {
        strings = selectedLocalization[language];
    }
    return strings;
};